// extracted by mini-css-extract-plugin
export default {"link":"styles_link__u3vtd","mobile":"styles_mobile__QUrzf"};